import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import chessslogo from '../images/chessslogo.png';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { isProfane } from '../util/filterProfanity';
// import ReCAPTCHA from 'react-google-recaptcha'; // Removed - using rate limiting instead
// Rate limiting
import { checkRateLimit } from '../util/rateLimiter';
import { getRateLimit, buildGlobalRateKey } from '../util/rateLimitConfig';

// MUI Stuff
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
// Redux stuff
import { connect } from 'react-redux';
import { signupUser } from '../redux/actions/userActions';

const styles = (theme) => ({
  form: theme.form,
  image: theme.image,
  pageTitle: theme.pageTitle,
  textField: theme.textField,
  customError: theme.customError,
  button: theme.button,
  progress: theme.progress,
});

class signup extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: '',
      confirmPassword: '',
      handle: '',
      errors: {},
      checkingUsername: false,
      agreedToTerms: false,
      rateLimitError: ''
    };
    this.usernameTimeout = null;
  }
  componentDidUpdate(prevProps) {
    if (this.props.UI.errors && this.props.UI.errors !== prevProps.UI.errors) {
      this.setState({ errors: this.props.UI.errors });
    }
  }
  // Check if username exists with debounce
  checkUsernameAvailability = (username) => {
    // Clear any existing timeout
    if (this.usernameTimeout) {
      clearTimeout(this.usernameTimeout);
    }

    if (!username || username.length < 3) return;

    this.setState({ checkingUsername: true });

    // Set a new timeout
    this.usernameTimeout = setTimeout(() => {
      axios.get(`/user/${username.toLowerCase()}/check`)
        .then(res => {
          // Make sure we have the expected response format
          if (res.data && res.data.exists !== undefined) {
            const exists = res.data.exists;
            if (exists) {
              this.setState(prevState => ({
                errors: {
                  ...prevState.errors,
                  handle: 'This username is already taken'
                },
                checkingUsername: false
              }));
            } else {
              // Username is available, clear any existing error
              this.setState(prevState => {
                const newErrors = { ...prevState.errors };
                delete newErrors.handle;
                return {
                  errors: newErrors,
                  checkingUsername: false
                };
              });
            }
          } else {
            // Unexpected response format
            console.error('Invalid response format:', res.data);
            this.setState({ checkingUsername: false });
          }
        })
        .catch(err => {
          console.error('Error checking username:', err);
          this.setState({ checkingUsername: false });
        });
    }, 500); // Debounce for 500ms
  };
  handleSubmit = (event) => {
    event.preventDefault();

    // Client-side validation before submission
    const errors = {};

    // Basic email format regex (something@something.something)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!this.state.email) {
      errors.email = 'Email is required';
    } else if (!emailRegex.test(this.state.email)) {
      errors.email = 'Please enter a valid email address';
    }
    if (!this.state.password) errors.password = 'Password is required';
    if (this.state.password !== this.state.confirmPassword)
      errors.confirmPassword = 'Passwords must match';
    if (!this.state.handle) errors.handle = 'Username is required';
    if (this.state.handle && this.state.handle.length > 15)
      errors.handle = 'Username cannot exceed 15 characters';

    // Validate username format (only letters and numbers allowed)
    const usernameRegex = /^[a-zA-Z0-9]+$/;
    if (this.state.handle && !usernameRegex.test(this.state.handle)) {
      errors.handle = 'Username can only contain letters and numbers';
    }
    
    // Check for profanity in username
    if (this.state.handle && isProfane(this.state.handle)) {
      errors.handle = 'Inappropriate language not allowed in usernames';
    }

    // Ensure terms agreement
    if (!this.state.agreedToTerms) {
      errors.agreedToTerms = 'You must agree to the Terms and Conditions.';
    }

    // Check if there are validation errors
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    // Rate limiting check for signup attempts
    const config = getRateLimit('SIGNUP_ATTEMPT', 'free');
    const rateKey = buildGlobalRateKey('anonymous', 'signup_attempt');
    
    const isLimited = checkRateLimit({
      key: rateKey,
      limit: config.limit,
      windowMs: config.windowMs
    });

    if (isLimited) {
      this.setState({ 
        rateLimitError: 'Too many signup attempts. Please wait then try again.',
        errors: {}
      });
      return;
    }

    // Clear any previous rate limit errors
    this.setState({ rateLimitError: '' });

    // Proceed directly with signup
    const newUserData = {
      email: this.state.email,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
      handle: this.state.handle,
      recaptchaToken: 'dummy-token' // Temporary until backend is deployed
    };
    
    this.props.signupUser(newUserData, this.props.history);
  };
  // Removed reCAPTCHA handlers - using rate limiting instead
  handleChange = (event) => {
    const { name, value } = event.target;

    // Handle checkbox using separate handler
    if (event.target.type === 'checkbox') {
      this.setState({ [name]: event.target.checked });
      return;
    }

    // For handle field, limit to 15 characters
    if (name === 'handle' && value.length > 15) {
      return; // Prevent updates that would exceed 15 characters
    }

    // For handle field, only allow letters and numbers
    if (name === 'handle') {
      // Only allow alphanumeric characters (letters and numbers)
      const alphanumericOnly = value.replace(/[^a-zA-Z0-9]/g, '');

      // If the input contains special characters, use the filtered version
      if (alphanumericOnly !== value) {
        this.setState({
          [name]: alphanumericOnly
        }, () => {
          if (alphanumericOnly.length > 2) {
            this.checkUsernameAvailability(alphanumericOnly);
          }
        });
        return;
      }
    }

    this.setState({
      [name]: value
    }, () => {
      // Check username availability when handle changes
      if (name === 'handle' && value.length > 2) {
        this.checkUsernameAvailability(value);
      }
    });
  };

  // Separate handler kept for clarity (in case we need special logic later)
  // handleCheckboxChange = (event) => {
  //   this.setState({ agreedToTerms: event.target.checked });
  // };
  render() {
    const {
      classes,
      UI: { loading }
    } = this.props;
    const { errors, rateLimitError } = this.state;
    const { email, password, confirmPassword, handle, agreedToTerms, checkingUsername } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isFormValid =
      email.trim() !== '' &&
      emailRegex.test(email.trim()) &&
      password.trim() !== '' &&
      confirmPassword.trim() !== '' &&
      password === confirmPassword &&
      handle.trim().length >= 3 &&
      !checkingUsername &&
      agreedToTerms &&
      Object.keys(errors).length === 0;

    const isDisabled = loading || !isFormValid;


    return (
      <div className="app-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="login-container" >
          <Grid container className={classes.form} style={{
            border: '5px solid gold',
            margin: '0px',
            width: '100%',
            maxWidth: '600px',
            minHeight: '500px',
            padding: '20px',
            backgroundColor: 'lightslategray',
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>

            <Grid item style={{
              width: '100%',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
              <img src={chessslogo} alt="app icon" className={classes.image} style={{ maxWidth: '100px' }} />
              <div style={{
                color: 'gold',
                fontSize: 'clamp(24px, 5vw, 36px)',
                fontWeight: 'bold',
                marginBottom: '10px'
              }}>
                Sign Up to Begin
              </div>

              <form noValidate onSubmit={this.handleSubmit} style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '25px'
              }}>
                {/* Rate limit error message */}
                {rateLimitError && (
                  <div style={{
                    color: 'white',
                    backgroundColor: '#ff6b6b',
                    padding: '10px',
                    borderRadius: '4px',
                    marginBottom: '10px',
                    width: '90%',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: '14px',
                    margin: '0 auto 10px auto'
                  }}>
                    {rateLimitError}
                  </div>
                )}

                {/* Form-level error message */}
                {/* {Object.keys(errors).length > 0 && (
                  <div style={{
                    color: 'white',
                    backgroundColor: '#ff0000',
                    padding: '10px',
                    borderRadius: '4px',
                    marginTop: '10px',
                    marginBottom: '10px',
                    width: '90%',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: '16px'
                  }}>
                    Please fix the errors below to continue
                  </div>
                )} */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '100%',
                  gap: '15px'
                }}>
                  {/* Row 1: Email and Username */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '90%',
                    gap: '15px'
                  }}>
                    {/* Email Field */}
                    <div style={{ flex: 1 }}>
                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        marginBottom: '5px' 
                      }}>
                        <div style={{ color: 'black', textAlign: 'left', fontWeight: 'bold' }}>Email</div>
                        {errors.email && (
                          <div style={{ color: '#ff0000', fontSize: '14px', textAlign: 'right', fontWeight: 'bold' }}>
                            {errors.email}
                          </div>
                        )}
                      </div>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Your email address"
                        value={this.state.email}
                        onChange={this.handleChange}
                        style={{
                          width: '100%',
                          padding: '15px',
                          fontSize: '16px',
                          border: errors.email ? '5px solid #ff0000' : '5px solid black',
                          borderRadius: '4px',
                          background: 'white',
                          color: 'black',
                          boxSizing: 'border-box'
                        }}
                      />
                    </div>

                    {/* Username Field */}
                    <div style={{ flex: 1 }}>
                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        marginBottom: '5px' 
                      }}>
                        <div style={{ color: 'black', textAlign: 'left', fontWeight: 'bold' }}>Username</div>
                        {this.state.checkingUsername ? (
                          <div style={{ color: '#3066be', fontSize: '14px', textAlign: 'right', fontWeight: 'bold' }}>
                            Checking...
                          </div>
                        ) : errors.handle ? (
                          <div style={{ color: '#ff0000', fontSize: '14px', textAlign: 'right', fontWeight: 'bold' }}>
                            {errors.handle}
                          </div>
                        ) : this.state.handle && this.state.handle.length > 2 ? (
                          <div style={{ color: 'green', fontSize: '14px', textAlign: 'right', fontWeight: 'bold' }}>
                            Available
                          </div>
                        ) : this.state.handle ? (
                          <div style={{ color: '#3066be', fontSize: '14px', textAlign: 'right', fontWeight: 'bold' }}>
                            At least 3 characters
                          </div>
                        ) : null}
                      </div>
                      <input
                        id="handle"
                        name="handle"
                        type="text"
                        maxLength={15}
                        placeholder="Create a username"
                        value={this.state.handle}
                        onChange={this.handleChange}
                        style={{
                          width: '100%',
                          padding: '15px',
                          fontSize: '16px',
                          border: errors.handle ? '5px solid #ff0000' : '5px solid black',
                          borderRadius: '4px',
                          background: 'white',
                          color: 'black',
                          boxSizing: 'border-box'
                        }}
                      />
                    </div>
                  </div>

                  {/* Row 2: Password and Confirm Password */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '90%',
                    gap: '15px'
                  }}>
                    {/* Password Field */}
                    <div style={{ flex: 1 }}>
                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        marginBottom: '5px' 
                      }}>
                        <div style={{ color: 'black', textAlign: 'left', fontWeight: 'bold' }}>Password</div>
                        {errors.password && (
                          <div style={{ color: '#ff0000', fontSize: '14px', textAlign: 'right', fontWeight: 'bold' }}>
                            {errors.password}
                          </div>
                        )}
                      </div>
                      <input
                        id="password"
                        name="password"
                        type="password"
                        placeholder="Create a password"
                        value={this.state.password}
                        onChange={this.handleChange}
                        style={{
                          width: '100%',
                          padding: '15px',
                          fontSize: '16px',
                          border: errors.password ? '5px solid #ff0000' : '5px solid black',
                          borderRadius: '4px',
                          background: 'white',
                          color: 'black',
                          boxSizing: 'border-box'
                        }}
                      />
                    </div>

                    {/* Confirm Password Field */}
                    <div style={{ flex: 1 }}>
                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        marginBottom: '5px' 
                      }}>
                        <div style={{ color: 'black', textAlign: 'left', fontWeight: 'bold' }}>Confirm Password</div>
                        {errors.confirmPassword && (
                          <div style={{ color: '#ff0000', fontSize: '14px', textAlign: 'right', fontWeight: 'bold' }}>
                            {errors.confirmPassword}
                          </div>
                        )}
                      </div>
                      <input
                        id="confirmPassword"
                        name="confirmPassword"
                        type="password"
                        placeholder="Confirm your password"
                        value={this.state.confirmPassword}
                        onChange={this.handleChange}
                        style={{
                          width: '100%',
                          padding: '15px',
                          fontSize: '16px',
                          border: errors.confirmPassword ? '5px solid #ff0000' : '5px solid black',
                          borderRadius: '4px',
                          background: 'white',
                          color: 'black',
                          boxSizing: 'border-box'
                        }}
                      />
                    </div>
                  </div>

                  {/* Removed reCAPTCHA - using backend rate limiting instead */}

                  {/* Terms Agreement Checkbox */}
                  <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    width: '90%',
                    justifyContent: 'center',
                  }}>
                    <input
                      id="agreedToTerms"
                      name="agreedToTerms"
                      type="checkbox"
                      checked={this.state.agreedToTerms}
                      onChange={this.handleChange}
                      style={{ transform: 'scale(1.5)', marginTop: '20px' }}
                    />
                    <label htmlFor="agreedToTerms" style={{ color: 'white', fontSize: '14px', marginTop: '16px' }}>
                      I agree to the&nbsp;
                      <a href="/Terms" target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>
                        Platform Terms 
                      </a>
                      &nbsp;and&nbsp;
                      <a href="/Privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>
                        Privacy Policy
                      </a>
                    </label>
                  </div>
                  {errors.agreedToTerms && (
                    <div style={{ color: '#ff0000', fontSize: '14px', width: '90%', textAlign: 'left', fontWeight: 'bold' }}>
                      {errors.agreedToTerms}
                    </div>
                  )}

                  {/* Signup Button */}
                  <button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isDisabled}
                    style={{
                      width: '55%',
                      padding: '15px',
                      fontSize: 'clamp(16px, 2vw, 20px)',
                      backgroundColor: isDisabled ? '#6c757d' : '#ff0050',
                      border: isDisabled ? '3px solid #6c757d' : '3px solid gold',
                      color: isDisabled ? '#ddd' : 'gold',
                      borderRadius: '5px',
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      fontWeight: 'bold',
                      marginTop: '17px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      opacity: isDisabled ? 0.7 : 1
                    }}>
                    {loading ? (
                      <CircularProgress size={24} style={{ color: 'gold' }} />
                    ) : (
                      'SIGN-UP'
                    )}
                  </button>
                  
                  {/* Security Notice */}
                  
                </div>

                <div style={{
                  fontSize: 'clamp(14px, 1.5vw, 16px)',
                  color: 'blue'
                }}>
                  Already have an account? <Link to="/login" style={{ color: 'blue', textDecoration: 'underline' }}>Login here</Link>
                </div>

                {/* {errors.general && (
                  <div style={{
                    color: '#ff0000',
                    fontSize: '16px',
                    marginTop: '10px',
                    textAlign: 'center',
                    padding: '10px',
                    backgroundColor: 'rgba(255, 0, 0, 0.1)',
                    border: '1px solid #ff0000',
                    borderRadius: '4px',
                    width: '90%',
                    fontWeight: 'bold'
                  }}>
                    {errors.general}
                  </div>
                )} */}
              </form>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

signup.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
  signupUser: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI
});

export default connect(
  mapStateToProps,
  { signupUser }
)(withStyles(styles)(signup));
